var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgExternalLink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.26339 5.26333C6.15882 5.26333 5.26339 6.15876 5.26339 7.26332V14.6033C5.26339 15.7078 6.15882 16.6033 7.26339 16.6033H14.6033C15.7079 16.6033 16.6033 15.7078 16.6033 14.6033V12.2534C16.6033 11.8852 16.9018 11.5868 17.27 11.5868C17.6382 11.5868 17.9367 11.8852 17.9367 12.2534V14.6033C17.9367 16.4442 16.4443 17.9366 14.6033 17.9366H7.26339C5.42244 17.9366 3.93005 16.4442 3.93005 14.6033V7.26332C3.93005 5.42237 5.42244 3.92999 7.26339 3.92999H9.61322C9.98141 3.92999 10.2799 4.22847 10.2799 4.59666C10.2799 4.96485 9.98141 5.26333 9.61322 5.26333H7.26339ZM12.3789 4.59666C12.3789 4.22847 12.6774 3.92999 13.0456 3.92999H15.9367C17.0413 3.92999 17.9367 4.82542 17.9367 5.92999V8.29303C17.9367 8.66122 17.6382 8.9597 17.27 8.9597C16.9018 8.9597 16.6034 8.66122 16.6034 8.29303V6.20596L11.4047 11.4046C11.1444 11.6649 10.7223 11.6649 10.4619 11.4046C10.2016 11.1442 10.2016 10.7221 10.4619 10.4618L15.6604 5.26333H13.0456C12.6774 5.26333 12.3789 4.96485 12.3789 4.59666Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgExternalLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/external-link.9b95bdf983c37c073e1cab4fac2dabd5.svg";